import Stack from "../Utils/Stack.styled";
import ButtonContainer from "./Button.styled";
import Paragraph from "../Utils/Paragraph.styled";
import { useState } from "react";
import Icon from "../Icon/Icon";

const Button = ({
  label,
  type,
  defaultColor,
  hoverColor,
  background,
  iconSize,
  fontSize,
  padding,
  onClick,
  disabled,
}) => {
  const [strokeColor, setStrokeColor] = useState(
    defaultColor ? defaultColor : "black"
  );

  const RenderIcon = () => {
    return <Icon color={strokeColor} size={iconSize || "20px"} type={type} />;
  };

  const RenderLabel = () => {
    return (
      label && (
        <Paragraph
          size={fontSize || "12px"}
          color={strokeColor}
          width="max-content"
        >
          {label}
        </Paragraph>
      )
    );
  };

  return (
    <ButtonContainer
      disabled={disabled}
      padding={padding}
      background={background}
      onClick={onClick}
      onMouseEnter={() => setStrokeColor(hoverColor ? hoverColor : "white")}
      onMouseLeave={() => setStrokeColor(defaultColor ? defaultColor : "black")}
    >
      <Stack
        direction="row"
        gap="8"
        alignItems="center"
        justifyContent="center"
      >
        <RenderIcon />
        <RenderLabel />
      </Stack>
    </ButtonContainer>
  );
};

export default Button;
